import React from 'react';
import Small from './components/Small';
import Large from './components/Large';
var RatingsWidget = function (_a) {
    var className = _a.className, _b = _a.template, template = _b === void 0 ? 'small' : _b, rating = _a.rating, totalCount = _a.totalCount, feedbackStats = _a.feedbackStats, countryCode = _a.countryCode;
    return React.createElement(React.Fragment, null,
        template === 'small' && rating && React.createElement(Small, { className: className, rating: rating, totalCount: totalCount }),
        template === 'large' && feedbackStats && React.createElement(Large, { feedbackStats: feedbackStats, className: className, countryCode: countryCode }));
};
export default RatingsWidget;
